import React from 'react'
import styled from 'styled-components'
import { Row, Col, Layout } from 'antd'
import { PrimaryButton } from 'Components/Shared/Button'
const { Footer } = Layout

type Props = {
  onReject?: () => void
  onApprove?: () => void
}

const FooterView: React.FC<Props> = ({ onReject, onApprove }) => {
  return (
    <Footer className="detail-page-footer">
      <FooterContent>
        <Row type="flex" justify="space-between" align="middle">
          <Col />
          <Col>
            <ContentLine>
              <Button>
                <PrimaryButton
                  text="ไม่อนุมัติ"
                  onClick={onReject}
                  btnType="Cancel"
                />
              </Button>
              <Button>
                <PrimaryButton
                  text="อนุมัติ"
                  onClick={onApprove}
                  btnType="Approve"
                />
              </Button>
            </ContentLine>
          </Col>
        </Row>
      </FooterContent>
    </Footer>
  )
}

const FooterContent = styled.div`
  max-width: 1110px;
  margin: 0 auto;
  color: #000;
  font-size: 20px;
  padding-right: 20px;
`

const ContentLine = styled.div`
  float: left;
  display: inline-flex;
  align-items: center;
`

const Button = styled.div`
  width: 160px;
  margin-left: 16px;
`

export default FooterView
